import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f4d8d94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "investigation-details-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "line1" }, "Investigation details")
], -1))
const _hoisted_3 = { class: "columns mt-3" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Trust account INV ID", -1))
const _hoisted_6 = { class: "fielddata" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Commencement date", -1))
const _hoisted_8 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Allocation date", -1))
const _hoisted_10 = { class: "fielddata" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Investigation type", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Investigator", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_17 = { class: "column" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Satisfactory reply received", -1))
const _hoisted_19 = { class: "fielddata" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Re-inspection ordered within 18 months", -1))
const _hoisted_21 = { class: "fielddata" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Was S165 report to PSD issued", -1))
const _hoisted_23 = { class: "fielddata" }
const _hoisted_24 = { class: "column" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Result of Report", -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Reply required", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Status", -1))
const _hoisted_30 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_33 = { class: "columns" }
const _hoisted_34 = { class: "column" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Trust accounting system", -1))
const _hoisted_36 = { class: "column" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "CM accounting system", -1))
const _hoisted_38 = { class: "column" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "PM accounting system", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_41 = { class: "breaches" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Breaches", -1))
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  style: {"display":"flex"},
  class: "mb-3"
}
const _hoisted_45 = {
  style: {"min-width":"4em"},
  class: "breach-code"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_47 = { class: "iwps" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "IWP", -1))
const _hoisted_49 = { class: "iwp-item" }
const _hoisted_50 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_51 = { class: "mb-2 mr-2" }
const _hoisted_52 = { style: {"text-align":"right"} }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_55 = { class: "notes" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Investigator notes", -1))
const _hoisted_57 = { class: "mb-2" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_59 = { class: "row mt-4" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Finalisation", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Any working papers you need to update before proceeding? This will lock the IWP and set the status to ‘Closed’.\"", -1))

export function render(_ctx, _cache) {
  const _component_date_picker = _resolveComponent("date-picker")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")
  const _component_AddeditIWPModal = _resolveComponent("AddeditIWPModal")
  const _component_FilePreview = _resolveComponent("FilePreview")
  const _component_AlertBox = _resolveComponent("AlertBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[10] || (_cache[10] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _hoisted_2
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(this.investigation.id), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_7,
                (_ctx.status == 2)
                  ? (_openBlock(), _createBlock(_component_date_picker, {
                      key: 0,
                      class: "fieldname",
                      value: _ctx.commencementDate,
                      "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.commencementDate) = $event)),
                      format: "DD/MM/YYYY",
                      "input-class": "narrow",
                      onChange: _cache[1] || (_cache[1] = $event => (_ctx.checkCanSubmit()))
                    }, null, 8, ["value"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$formatDate(this.investigation.commencementDate)), 1))
              ]),
              _createElementVNode("div", null, [
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$formatDate(this.investigation.dateOfAllocation)), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_11,
                (_ctx.status == 2)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      class: "fielddata",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((this.investigation.investigationType.id) = $event)),
                      style: {"width":"100%"},
                      onChange: _cache[3] || (_cache[3] = $event => (_ctx.checkCanSubmit()))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.investigationTypes, (t) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: t.id
                        }, _toDisplayString(t.name), 9, _hoisted_12))
                      }), 256))
                    ], 544)), [
                      [_vModelSelect, this.investigation.investigationType.id]
                    ])
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(this.investigation.investigationType.name), 1))
              ]),
              _createElementVNode("div", null, [
                _hoisted_14,
                (_ctx.status == 2)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      class: "fielddata",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((this.investigation.trustTeamMember.id) = $event)),
                      style: {"width":"100%"},
                      onChange: _cache[5] || (_cache[5] = $event => (_ctx.checkCanSubmit()))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.investigators, (t) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: t.id
                        }, _toDisplayString(t.displayName), 9, _hoisted_15))
                      }), 256))
                    ], 544)), [
                      [_vModelSelect, this.investigation.trustTeamMember.id]
                    ])
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(this.investigation.trustTeamMember?.displayName), 1))
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", null, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(this.investigation.isSatisfactoryReplyReceived ? 'Yes' : 'No'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, _toDisplayString(this.investigationDetails.isReInspectionOrderedWithin18Months ? 'Yes' :
                'No'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_22,
                _createElementVNode("span", _hoisted_23, _toDisplayString(this.investigation.isS165reportIssued ? 'Yes' : 'No'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", null, [
                _hoisted_25,
                (_ctx.status > 2 && this.investigation.reportResult)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((this.investigation.reportResult.id) = $event)),
                      class: "fielddata",
                      onChange: _cache[7] || (_cache[7] = $event => (_ctx.checkCanSubmit())),
                      style: {"width":"100%"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportResults, (r) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: r.id
                        }, _toDisplayString(r.name), 9, _hoisted_26))
                      }), 256))
                    ], 544)), [
                      [_vModelSelect, this.investigation.reportResult.id]
                    ])
                  : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(this.investigation.reportResult?.name), 1))
              ]),
              _createElementVNode("div", null, [
                _hoisted_28,
                _createTextVNode(" " + _toDisplayString(_ctx.investigation.isReplyRequired ? 'Yes' : 'No') + " ", 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_29,
                _createElementVNode("span", null, _toDisplayString(this.investigation.investigationStatus.name), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            (_ctx.loadingContent)
              ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                  key: 0,
                  style: {"width":"200px"}
                }))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn-primary sml mb-3",
              disabled: !_ctx.canSubmit,
              onClick: _cache[8] || (_cache[8] = $event => (_ctx.submitChanges()))
            }, "Save", 8, _hoisted_31)
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              (_ctx.loadingContent && !!this.accountingApps)
                ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                    key: 0,
                    style: {"width":"200px"}
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, _toDisplayString(this.accountingApps?.trustAccountingApp?.name), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$formatMMYYYY(this.accountingApps?.trustMonthYear)), 1),
              _createElementVNode("div", null, _toDisplayString(this.accountingApps?.trustAmount ? '$ ' +this.accountingApps?.trustAmount: ''), 1),
              _createElementVNode("div", null, _toDisplayString(this.accountingApps?.trustAccountNumber), 1)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", null, _toDisplayString(this.accountingApps?.controlMoneyAccountingApp?.name), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$formatMMYYYY(this.accountingApps?.controlMoneyMonthYear)), 1),
              _createElementVNode("div", null, _toDisplayString(this.accountingApps?.controlMoneyAmount ? '$ ' + this.accountingApps?.controlMoneyAmount : ''), 1),
              _createElementVNode("div", null, _toDisplayString(this.accountingApps?.controlMoneyAccountNumber), 1)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", null, _toDisplayString(this.accountingApps?.powerMoneyAccountingApp?.name), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$formatMMYYYY(this.accountingApps?.powerMoneyMonthYear)), 1),
              _createElementVNode("div", null, _toDisplayString(this.accountingApps?.powerMoneyAmount ? '$ ' + this.accountingApps?.powerMoneyAmount : ''), 1),
              _createElementVNode("div", null, _toDisplayString(this.accountingApps?.powerMoneyAccountNumber), 1)
            ])
          ])
        ]),
        _hoisted_40,
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          (_ctx.loadingContent && !!this.breaches)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                style: {"width":"200px"}
              }))
            : _createCommentVNode("", true),
          (this.breaches && !_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.breaches, (b) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("h4", _hoisted_45, _toDisplayString(b.breachCode), 1),
                    _createElementVNode("span", null, _toDisplayString(b.description), 1)
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_46,
        _createElementVNode("div", _hoisted_47, [
          _hoisted_48,
          (_ctx.loadingContent || _ctx.loadingIWPList)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                style: {"width":"200px"}
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workingPapers, (w) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("strong", null, _toDisplayString(w.file?.fileName), 1),
                    _createElementVNode("div", null, _toDisplayString(w.information), 1)
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("button", {
                      class: "btn btn-default sml",
                      onClick: $event => (_ctx.getFileStream(w))
                    }, "View", 8, _hoisted_53)
                  ])
                ])
              ]))
            }), 256))
          ])
        ]),
        _hoisted_54,
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (n) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_57, [
                _createElementVNode("i", null, [
                  _createElementVNode("b", null, _toDisplayString(n.notesType?.description), 1),
                  _createTextVNode(", - " + _toDisplayString(n.trustTeamMember?.displayName) + " " + _toDisplayString(_ctx.$formatDateTimeTypeA(n.createdOn)), 1)
                ]),
                _createElementVNode("div", null, _toDisplayString(n.content), 1)
              ]))
            }), 256))
          ])
        ]),
        _hoisted_58,
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: _cache[9] || (_cache[9] = $event => (_ctx.closeModal())),
            disabled: _ctx.loadingContent
          }, "Back", 8, _hoisted_60)
        ])
      ]),
      _: 1
    }),
    (_ctx.showAddEditIWPModal)
      ? (_openBlock(), _createBlock(_component_AddeditIWPModal, {
          key: 0,
          iWP: _ctx.selectedIWP,
          onCloseModal: _cache[11] || (_cache[11] = $event => {_ctx.showAddEditIWPModal = false;})
        }, null, 8, ["iWP"]))
      : _createCommentVNode("", true),
    _createVNode(_component_FilePreview, {
      showPreview: _ctx.showFilePreview,
      previewFile: _ctx.selectedFileForPreview,
      state: _ctx.filePreviewState,
      disableBackgroundScroll: true,
      onCloseFilePreview: _cache[12] || (_cache[12] = $event => (_ctx.closeFilePreview()))
    }, null, 8, ["showPreview", "previewFile", "state"]),
    (_ctx.showFinalisationAlert)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 1,
          onClose: _cache[15] || (_cache[15] = $event => (_ctx.showFinalisationAlert = false))
        }, {
          header: _withCtx(() => [
            _hoisted_61
          ]),
          body: _withCtx(() => [
            _hoisted_62
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-secondary sml",
              onClick: _cache[13] || (_cache[13] = $event => (_ctx.cancelFinalisation()))
            }, "Update"),
            _createElementVNode("button", {
              class: "btn btn-tertiary sml",
              onClick: _cache[14] || (_cache[14] = $event => (_ctx.updateCompletedInvestigation()))
            }, "Continue")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}